var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandingSvgrepocom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7422 4.71691C15.1468 1.68738 19.5326 6.56539 16.4507 8.56207C14.0559 10.1137 11.2443 7.69522 12.3687 5.59081",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7091 26.251C13.3285 26.251 13.5893 26.0139 13.5893 25.8398C13.5893 25.6657 13.8482 21.9734 13.8859 21.222C13.916 20.6191 13.8998 17.9252 13.8998 17.7116C13.8998 17.498 13.9697 17.4268 13.7909 17.2822C13.612 17.1376 11.1257 15.7591 10.7585 15.0656C10.4722 14.5251 10.8102 14.6152 11.0276 14.3552C11.2449 14.0952 12.7091 11.3258 13.3168 11.1346C13.9246 10.9435 14.1098 10.912 14.3159 10.8742C14.8629 10.7745 15.8918 10.465 16.4382 10.6889C16.7667 10.8232 19.025 12.798 19.2226 13.1741C19.3878 13.489 19.3837 13.345 19.1605 13.8397C18.9527 14.2996 18.6311 14.8519 18.3119 15.3024C17.9111 15.8682 17.1023 16.643 16.7378 17.1678C16.4572 17.572 16.2986 20.9467 16.2986 21.4543C16.2986 21.9943 16.4259 24.9992 16.4372 25.293C16.4594 25.874 16.3514 25.9096 16.7378 26.1907C16.9038 26.3113 17.3637 26.0491 17.3809 26.1907",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8529 17.374L13.1211 11.0625",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5971 17.7442C16.719 16.3752 16.78 15.3932 16.78 14.7979C16.78 14.2027 16.658 12.8065 16.4141 10.6094",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandingSvgrepocom);
export default __webpack_public_path__ + "static/media/standing_svgrepo.com.b34b6030d325c0a4450ca94d2092e674.svg";
export { ForwardRef as ReactComponent };